import { z } from 'zod';

// Helper function to capitalize the first letter and make the rest lowercase
const capitalizeFirstLetter = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const createContactSchema = (t: (key: string, defaultText: string) => string) => {
return z.object({
  FirstName: z.string()
    .min(1, { message: t("validation_firstName", "First Name is required.") })
    // Regex to ensure only a-z characters (case-insensitive) are present in the input
    .regex(/^[a-zA-Z0-9]+$/, { message: t("validation_firstName_specialChar", "First Name cannot contain special characters.") })
    // Transform the input to have the first letter uppercase and rest lowercase
    .transform((name) => capitalizeFirstLetter(name)),

  LastName: z.string()
    .min(1, { message: t("validation_lastName", "Last Name is required.") })
    .regex(/^[a-zA-Z0-9]+$/, { message: t("validation_lastName_specialChar", "Last Name cannot contain special characters.") })
    .transform((name) => capitalizeFirstLetter(name)),

  Email: 
    z.string()
    .min(1, {message: t("validation_emailRequired", "Email is required.")})
    .email({ message: t("validation_emailFormat", "Invalid email address format.") }),

    Message: z.string()
    .min(1, {message: t("validation_messageRequired", "Please provide more details.")})
})};

export type ContactUsSchema = z.infer<ReturnType<typeof createContactSchema>>;
